var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "退货邀请客户自助下单",
        visible: _vm.dialogVisible,
        "before-close": _vm.closeDialog,
        width: "750px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "bg-tips",
          staticStyle: { "text-align": "left", padding: "0px 0px 10px 0px" },
        },
        [
          _c("img", {
            staticClass: "bg-tips-img",
            attrs: {
              src: require("@/assets/images/returnPickupPrint/bg_Tips.png"),
              alt: "",
            },
          }),
          _c("div", { staticClass: "bg-tips-text1" }, [
            _vm._v(
              "1、客户扫码下单后，需您确认审核通过才会下单成功，也可设置自动审核；"
            ),
          ]),
          _c("div", { staticClass: "bg-tips-text2" }, [
            _vm._v(
              "2、修改配置信息后，原二维码与链接将失效，若您需要保留原二维码与链接功能， 请使用新增二维码与链接功能。"
            ),
          ]),
        ]
      ),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "y-p-r",
          attrs: { model: _vm.form, "label-width": "10px" },
        },
        [
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("付款方式")]),
          ]),
          _c("el-form-item", { attrs: { label: "", prop: "brokerage" } }, [
            _c(
              "div",
              {
                staticClass: "y-mt-15 y-p-r",
                class: { notClickSelf: _vm.loadingMaskLayer },
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.merchanPayFn },
                        model: {
                          value: _vm.merchanPayFlag,
                          callback: function ($$v) {
                            _vm.merchanPayFlag = $$v
                          },
                          expression: "merchanPayFlag",
                        },
                      },
                      [_vm._v("商家付运费")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "y-mt-10" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.brokerageFn },
                        model: {
                          value: _vm.brokerageFlag,
                          callback: function ($$v) {
                            _vm.brokerageFlag = $$v
                          },
                          expression: "brokerageFlag",
                        },
                      },
                      [_vm._v("加价寄件人付费返佣")]
                    ),
                    _vm.brokerageFlag && _vm.isAliNameFlag
                      ? _c("span", { staticClass: "y-ml-10" }, [
                          _vm._v("每单加价"),
                        ])
                      : _vm._e(),
                    _vm.brokerageFlag && _vm.isAliNameFlag
                      ? _c("el-input-number", {
                          staticClass: "y-ml-10",
                          attrs: {
                            precision: 1,
                            step: 0.5,
                            min: 0.5,
                            max: 2.0,
                            size: "small",
                            "step-strictly": true,
                          },
                          model: {
                            value: _vm.form.brokerage,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "brokerage", $$v)
                            },
                            expression: "form.brokerage",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" 元 "),
                    _c(
                      "span",
                      {
                        staticClass: "systemColor y-ml-10 y-c-p",
                        on: {
                          click: function ($event) {
                            return _vm.openBrokerageFn("1")
                          },
                        },
                      },
                      [_vm._v("查看详情")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "y-mt-10" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.buyerPaysShippingFn },
                        model: {
                          value: _vm.buyerPaysShippingFlag,
                          callback: function ($$v) {
                            _vm.buyerPaysShippingFlag = $$v
                          },
                          expression: "buyerPaysShippingFlag",
                        },
                      },
                      [_vm._v("不加价寄件人付运费")]
                    ),
                    _vm.buyerPaysShippingFlag
                      ? _c("span", { staticClass: "y-ml-10" }, [
                          _vm._v("寄件人付"),
                        ])
                      : _vm._e(),
                    _vm.buyerPaysShippingFlag
                      ? _c(
                          "el-select",
                          {
                            staticClass: "y-ml-10",
                            attrs: { clearable: "", placeholder: "请选择" },
                            model: {
                              value: _vm.buyerPaysShipping,
                              callback: function ($$v) {
                                _vm.buyerPaysShipping = $$v
                              },
                              expression: "buyerPaysShipping",
                            },
                          },
                          _vm._l(_vm.addPriceForOrderList, function (item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: { label: item.name, value: item.code },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticClass: "systemColor y-ml-10 y-c-p",
                        on: {
                          click: function ($event) {
                            return _vm.openBrokerageFn("2")
                          },
                        },
                      },
                      [_vm._v("查看详情")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("自动通过审核")]),
          ]),
          _c("el-form-item", { attrs: { label: "", prop: "autoAudit" } }, [
            _c(
              "div",
              { staticClass: "y-f y-f-a y-mt-10" },
              [
                _c("el-switch", {
                  model: {
                    value: _vm.form.autoAudit,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "autoAudit", $$v)
                    },
                    expression: "form.autoAudit",
                  },
                }),
                _c("span", { staticClass: "y-ml-10" }, [
                  _vm._v("开启后，客户扫码下单后，系统自动审核通过并下单成功"),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("退货收件地址")]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "addressId" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "y-w-600 y-mt-15",
                  attrs: {
                    "popper-append-to-body": false,
                    "popper-class": "y-w-600",
                    filterable: "",
                    "no-match-text": " ",
                    placeholder: "请选择退货收件地址",
                  },
                  model: {
                    value: _vm.form.addressId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "addressId", $$v)
                    },
                    expression: "form.addressId",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "systemColor y-ml-10 y-c-p",
                  on: {
                    click: function ($event) {
                      _vm.showAddReciverInfo = true
                    },
                  },
                },
                [_vm._v("新增地址")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("用户下单配置")]),
          ]),
          _c("el-form-item", { attrs: { label: "", prop: "originalOrder" } }, [
            _c(
              "div",
              { staticClass: "y-f y-f-a y-c-p y-mt-15" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.form.originalOrder,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "originalOrder", $$v)
                      },
                      expression: "form.originalOrder",
                    },
                  },
                  [_vm._v("用户下单时需填写原订单号")]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("上门取件时间")]),
          ]),
          _c("el-form-item", { attrs: { label: "", prop: "dayFlag" } }, [
            _c(
              "div",
              {
                staticClass: "y-f y-f-a y-c-p y-mt-15 y-fl-20",
                on: {
                  click: function ($event) {
                    _vm.form.dayFlag = "today"
                  },
                },
              },
              [
                _vm.form.dayFlag == "today"
                  ? _c("img", {
                      staticClass: "radio-icon",
                      attrs: {
                        src: require("@/assets/images/icon/radio_check_new.png"),
                      },
                    })
                  : _c("img", {
                      staticClass: "radio-icon radio-icon-uncheck",
                      attrs: {
                        src: require("@/assets/images/icon/radio_uncheck.png"),
                      },
                    }),
                _c("div", { staticClass: "y-ml-10 y-f-shrink" }, [
                  _vm._v("当日取"),
                ]),
                _c("div", { staticClass: "y-ml-10" }, [
                  _vm._v("消费者下单审核通过后，业务员联系消费者预约取件时间"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "y-f y-f-ab y-c-p y-mt-15 y-fl-20",
                on: {
                  click: function ($event) {
                    _vm.form.dayFlag = "nextDay"
                  },
                },
              },
              [
                _c("div", { staticClass: "y-f y-f-a y-mr-20" }, [
                  _vm.form.dayFlag == "nextDay"
                    ? _c("img", {
                        staticClass: "radio-icon",
                        attrs: {
                          src: require("@/assets/images/icon/radio_check_new.png"),
                        },
                      })
                    : _c("img", {
                        staticClass: "radio-icon radio-icon-uncheck",
                        attrs: {
                          src: require("@/assets/images/icon/radio_uncheck.png"),
                        },
                      }),
                  _c("div", { staticClass: "y-ml-10 y-f-shrink" }, [
                    _vm._v("定时取"),
                  ]),
                ]),
                _c("div", { staticClass: "align-self" }, [
                  _vm._v(
                    "消费者下单审核通过后，为消费者选择的取件时间，若审核时已过预约取件开始时间，将自动调整为审核时间后近2小时"
                  ),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("分享平台")]),
          ]),
          _c("el-form-item", { attrs: { label: "", prop: "channel" } }, [
            _c(
              "div",
              { staticClass: "y-f y-f-a y-c-p y-mt-15" },
              [
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.channel,
                      callback: function ($$v) {
                        _vm.channel = $$v
                      },
                      expression: "channel",
                    },
                  },
                  [
                    _c(
                      "el-checkbox",
                      { attrs: { label: "微信", disabled: "" } },
                      [_vm._v("微信")]
                    ),
                    _c(
                      "el-checkbox",
                      { attrs: { label: "淘宝", disabled: "" } },
                      [_vm._v("淘宝")]
                    ),
                    _c(
                      "el-checkbox",
                      { attrs: { label: "抖音", disabled: "" } },
                      [_vm._v("抖音")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeDialog } }, [_vm._v("取消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveSettingInfo } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _c("reciverInfo", {
        attrs: { value: _vm.showAddReciverInfo, isNotShowCompany: true },
        on: { close: _vm.closeReciverDialog },
      }),
      _vm.buyerPaysShippingDialogFlag
        ? _c("buyerPaysShippingDialog", {
            ref: "buyerPaysShippingDialog",
            attrs: {
              isShow: _vm.buyerPaysShippingDialogFlag,
              alipayName: _vm.alipayName,
              realNameId: _vm.realNameId,
            },
            on: {
              closeDialog: _vm.closeBuyerPaysShipping,
              changeBrokerage: _vm.changeBrokerage,
              openSaveAccount: _vm.openSaveAccount,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }